import React from "react";
import Left_menu from "./Left_menu";
import Header from "./Header";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  ProgressBar,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
// import './customer_style.css';
import Modal from "react-bootstrap/Modal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import axios from "axios";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import ReactLoading from "react-loading";
import config from "../../config";
import moment from "react-moment";
import download from "downloadjs";
import TablePagination from "@mui/material/TablePagination";
import { useNetworkState } from "react-use";
import Moment from "moment";
import {
  Ban,
  Copy,
  CornerUpLeft,
  FileEdit,
  Package,
  PackageOpen,
  Plus,
  RefreshCcw,
  ShoppingBag,
  ShoppingBasket,
  Trash,
  Truck,
  Upload,
} from "lucide-react";
import Footer from "../Footer";
const Customer_b2b_orders = () => {
  let navigate = useNavigate();
  const isOnline = useNetworkState();
  console.log("isONline  === ", isOnline);
  let userDetail = localStorage.getItem("ship_rocket_user");
  // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail);
  }
  const [packagestate, setpackageState] = React.useState([]);
  const [userstate, setUserState] = React.useState({});
  // const[loadingstate,setLoadingstate] = React.useState({loading:false})
  const [errorstate, seterrorstate] = React.useState({ message: "" });
  const [showBreakdown, setShowBreakdown] = React.useState(false);
  const [recordid, setRecordid] = React.useState({ record_id: "" });
  const [uploadModalState, setUploadModalState] = React.useState({
    show: false,
    excel_fle: "",
  });
  const [dimensionState, setdimensionState] = React.useState({
    companyDetail: [],
  });
  const [state, setState] = React.useState({
    shipment_list: [],
    isLoading: true,
  });
  const [shipmentstate, setshipStatus] = React.useState({
    shipment_status: null,
  });
  const [shipSelect, setShipSelect] = React.useState({
    shipment_id: "",
    cancel_reason: "",
  });
  const [modalState, setModalState] = React.useState({ show: false });
  const [sortOption, setSortOption] = React.useState("Recommended");
  const [sub, setSub] = React.useState(null);
  const [loadingstate, setLoadingstate] = React.useState(false);
  const [summarystate, setSummarystate] = React.useState(false);
  const [isLoading, setisLoading] = React.useState(true);
  const [syncLoading, setsyncLoading] = React.useState(false);
  const [selected, setSelected] = React.useState({
    select_count: 0,
    select_order_id: [],
  });
  const [searchstate, setsearchstate] = React.useState({ search_shipment: "" });
  const [alloctedata, setallocatedata] = React.useState([]);
  const [productselect, setProductselect] = React.useState({
    product_id: "",
    carrier_id: "",
  });
  const [otherStates, setOtherState] = React.useState({
    dstatus: "",
    activePage: 1,
    rowsPerPage: 20,
    page: 0,
    total_count: 0,
    onload: true,
  });
  // console.log("otherState ==== " , otherStates)
  // console.log("selected === " , selected)
  const [product, setproduct] = React.useState([]);
  const [onSubmitButton, setonSubmit] = React.useState(false);

  const [openOffcanvas, setOpenOffcanvas] = React.useState(false);
  const [openOffdetailcanvas, setOpenOffdetailcanvas] = React.useState(false);

  const [warehosuestate, setWarehouseState] = React.useState({ warehouse: "" });
  const [packageloading, setpackageloading] = React.useState({
    loading: false,
  });
  const [bookorder, setbookorder] = React.useState([]);
  console.log("bookorder", bookorder);
  const [otherState, setOtherStates] = React.useState({ submit_button: false });
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [date, setdate] = React.useState({ date: "" });
  const [paymentmode, setpaymentmode] = React.useState({
    cod: false,
    prepaid: false,
  });
  const [warehouse, setwarehouse] = React.useState([]);
  const [selectedWarehouses, setSelectedWarehouses] = React.useState([]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector(".home-section");
    if (homeSection) {
      homeSection.classList.toggle("sidebar-closed");
    }
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 5000,
  });

  React.useEffect(() => {
    shipment_list(null, 0, true);
  }, [date.date, paymentmode, selectedWarehouses]);

  // console.log("shipmentState",shipmentstate)
  React.useEffect(() => {
    shipment_list(null, 0, true);
    dimension_detail();
    get_warehouse();
    user();
  }, [otherStates.rowsPerPage]);
  const user = () => {
    let dataToSend = {};

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/user/find_customer_detail";
    //  console.log("headers =========> ", config.headers);
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("res ===" , res.data.output)
        setUserState(res.data.output);
        let response = res.data.ouptut;
        // console.log("response ===" , response)
        //   const obscuredAadhar = obscureAadharNumber(res.data.ouptut.aadhaar_number);
        // console.log("obscuredAadhar == " , obscuredAadhar)
        // setAadharNumber(obscuredAadhar);
      })
      .catch((error) => {
        // console.log(error);
      });
  };
  const shipment_list = (status, index = 0, onLoad) => {
    let dataToSend = {
      customer_id: userData.customer_id,
      find: searchstate.search_shipment,
      status: status,
      limit: otherStates.rowsPerPage,
      indexValue: index,
    };
    if (date.date != "") {
      dataToSend.date = date.date;
    }
    if (selectedWarehouses.length > 0) {
      dataToSend.warehouse = selectedWarehouses;
    }
    if (paymentmode.cod && !paymentmode.prepaid) {
      dataToSend.payment_mode = "cod";
    } else if (!paymentmode.cod && paymentmode.prepaid) {
      dataToSend.payment_mode = "prepaid";
    } else if (paymentmode.cod && paymentmode.prepaid) {
      dataToSend.payment_mode = "both";
    }

    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/shipment/customer_orders_b2b";

    // console.log("headers => ", config.headers);

    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        if (onLoad) {
          setOtherState({
            ...otherStates,
            total_count: res.data.count,
            page: index,
          });
        }
        setState({ shipment_list: res.data.output, isLoading: false });
        setisLoading(false);
      })
      .catch((error) => {
        //Hide Loader
        //   setLoadingstate({...loadingstate,loading:false})
        // console.log(error);
      });
  };
  const handlePageChange = (event, newPage) => {
    setOtherState({ ...otherStates, page: newPage });
    // console.log("newPage ", newPage);
    // getCountryList(newPage);
    shipment_list(shipmentstate.shipment_status, newPage, true);
  };
  const handleChangeRowsPerPage = (event, newPage) => {
    // console.log("event ", event.target.value);
    setOtherState({ ...otherStates, rowsPerPage: event.target.value });
  };

  const dimension_detail = () => {
    let full_api = config.apiUrl + `/user/get_company_info_api`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        setdimensionState({
          ...dimensionState,
          companyDetail: res.data.companyDetail,
        });
        // console.log("rnmmmmm", res);
      })
      .catch((e) => {
        // toast.configure()
        //toast.error("Some thing went wrong")
        // console.log("----error:   ", e);
      });
  };

  const get_warehouse = () => {
    let full_api = config.apiUrl + `/shipment/getAllWarehouse`;
    let sendData = {};

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        if (res.data.status == true) {
          setwarehouse(res.data.output);
        }
        console.log("rnmmmmm", res);
      })
      .catch((e) => {
        // toast.configure()
        //  toast.error("Some thing went wrong")
        console.log("----error:   ", e);
      });
  };

  const syncOrders = () => {
    setsyncLoading(true);
    let full_api = config.apiUrl + `/shipment/sync_orders`;
    let sendData = { customer_id: userData.customer_id };

    axios
      .post(full_api, sendData, { headers: config.headers })
      .then((res) => {
        // console.log("rnmmmmm", res);
        if (res.data.status == true) {
          setsyncLoading(false);
          shipment_list();
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#10b93b",
            type: "error",
            title: "Something Went Wrong!",
            color: "white",
          });
        }
      })
      .catch((e) => {
        // console.log("----error:   ", e);
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
        });
        Toast.fire({
          background: "#10b93b",
          type: "error",
          title: "Something Went Wrong!",
          color: "white",
        });
      });
  };

  const clone_order = (sub) => {
    // console.log("order_id")

    let dataToSend = {
      sender_name: sub.sender[0].name,
      sender_mobile: sub.sender[0].mobile,
      sender_email: sub.sender[0].email,
      sender_address: sub.sender[0].address,
      sender_city: sub.sender[0].city,
      sender_city_id: sub.sender[0].city_id,
      sender_state_name: sub.sender[0].state,
      sender_country_name: sub.sender[0].country,
      sender_country_code: sub.sender[0].country_code,
      sender_postal_code: sub.sender[0].pincode,
      receiver_name: sub.receiver[0].name,
      receiver_mobile: sub.receiver[0].mobile,
      receiver_email: sub.receiver[0].email,
      receiver_address: sub.receiver[0].address,
      receiver_city: sub.receiver[0].city,
      receiver_country_name: sub.receiver[0].country,
      receiver_country_code: sub.receiver[0].country_code,
      receiver_postal_code: sub.receiver[0].pincode,
      receiver_state_name: sub.receiver[0].state,
      receiver_state_id: sub.receiver[0].state_id,
      receiver_city_id: sub.receiver[0].city_id,
      return_name: sub.return[0].name,
      return_mobile: sub.return[0].mobile,
      return_email: sub.return[0].email,
      return_address: sub.return[0].address,
      return_city: sub.return[0].city,
      return_state_name: sub.return[0].state,
      return_country_name: sub.return[0].country,
      return_country_code: sub.return[0].country_code,
      return_postal_code: sub.return[0].pincode,
      payment_mode: sub.payment_mode,
      shipment_type: sub.type,
      cod_amount: sub.cod_amount,
      volumetric_weight: sub.volumetric_weight ? sub.volumetric_weight : 0,
      total_weight: sub.total_weight ? sub.total_weight : 0,
      dead_weight: sub.dead_weight ? sub.dead_weight : 0,
      length: sub.length,
      height: sub.height,
      width: sub.width,
      insurance_amount: sub.insurance_amount,
      type: sub.type,
      address_id: sub.address_id,
      order_id: "",
      order_date: "",
      mode: sub.mode,
      carrier_type: 2,
      order_type: sub.order_type ? (sub.order_type == "Fulfilled" ? 2 : 1) : 1,
      boxes: sub.boxes,
      invoices: sub.invoices,
      boxes_count: sub.boxes_count,
      rv_insurance: sub.rv_insurance,
      self: sub.self == false ? false : true,

      documents: sub.documents,
      lr_number: sub.lr_number ? sub.lr_number : "",
      order_description: sub.order_description,
      goods_code: sub.goods_code,
    };

    dataToSend.customer_id = userData.customer_id;
    console.log("datatoSend", dataToSend);

    let url = config.apiUrl + "/shipment/order_create";

    // setOtherState({ ...otherState, submit_button: false })
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((responseJson) => {
        // console.log("responseJson => ", responseJson.data.output);
        // setOtherState({ ...otherState, submit_button: true })
        if (responseJson.data.status == true) {
          shipment_list();
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#3659cd",
            type: "unsuccess",
            title: "Order created successfully.",
            color: "white",
          });
          setOpenOffdetailcanvas(false);
        } else {
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#a61c09",
            type: "unsuccess",
            title: "Something Went Wrong.",
            color: "white",
          });
        }
      });
  };

  const convertToYYYYMMDD = (inputDate) => {
    const dateParts = inputDate.split(/[-/]/); // Split by / or -
    // return `${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`;
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const edit_order = (sub) => {
    const formattedOrderDate = convertToYYYYMMDD(sub.order_date);

    // Create a query params object
    const queryParams = new URLSearchParams();

    // Add all the parameters in a more organized way
    queryParams.append("value", sub.mode === "Domestic" ? "0" : "1");
    queryParams.append("order_id", sub.order_number);
    queryParams.append("order_date", formattedOrderDate);
    queryParams.append("mode", sub.mode);
    queryParams.append("shipment_type", sub.type);
    queryParams.append("weight", sub.total_weight);
    queryParams.append("height", sub.height);
    queryParams.append("width", sub.width);
    queryParams.append("length", sub.length);
    queryParams.append("volumetric_weight", sub.volumetric_weight);
    queryParams.append("dead_weight", sub.dead_weight);
    queryParams.append("lr_number", sub.lr_number);
    queryParams.append("order_description", sub.order_description);
    queryParams.append("cod_amount", sub.cod_amount);
    queryParams.append(
      "boxes",
      encodeURIComponent(JSON.stringify(sub.boxes || []))
    );
    queryParams.append(
      "invoices",
      encodeURIComponent(JSON.stringify(sub.invoices || []))
    );
    queryParams.append("payment_mode", sub.payment_mode);
    queryParams.append("rv_insurance", sub.rv_insurance);
    queryParams.append("self", sub.self);
    queryParams.append(
      "documents",
      encodeURIComponent(JSON.stringify(sub.documents || []))
    );

    // Sender information
    if (sub.sender && sub.sender[0]) {
      const sender = sub.sender[0];
      queryParams.append("sender_name", sender.name);
      queryParams.append("sender_address", sender.address);
      queryParams.append("sender_country", sender.country);
      queryParams.append("sender_country_code", sender.country_code);
      queryParams.append("sender_postal_code", sender.pincode);
      queryParams.append("sender_city", sender.city);
      queryParams.append("sender_state_name", sender.state);
      queryParams.append("sender_mobile", sender.mobile);
      queryParams.append("sender_email", sender.email);
      queryParams.append("sender_city_id", sender.city_id);
      queryParams.append("sender_address_id", sub.address_id);
    }

    // Receiver information
    if (sub.receiver && sub.receiver[0]) {
      const receiver = sub.receiver[0];
      queryParams.append("receiver_name", receiver.name);
      queryParams.append("receiver_email", receiver.email);
      queryParams.append("receiver_mobile", receiver.mobile);
      queryParams.append("receiver_address", receiver.address);
      queryParams.append("receiver_country", receiver.country);
      queryParams.append("receiver_country_code", receiver.country_code);
      queryParams.append("receiver_postal_code", receiver.pincode);
      queryParams.append("receiver_city", receiver.city);
      queryParams.append("receiver_state_name", receiver.state);
      queryParams.append("receiver_state_id", receiver.state_id || "");
      queryParams.append("receiver_city_id", receiver.city_id || "");
    }

    // Return information
    if (sub.return && sub.return[0]) {
      const returnInfo = sub.return[0];
      queryParams.append("return_name", returnInfo.name);
      queryParams.append("return_email", returnInfo.email);
      queryParams.append("return_mobile", returnInfo.mobile);
      queryParams.append("return_address", returnInfo.address);
      queryParams.append("return_country", returnInfo.country);
      queryParams.append("return_country_code", returnInfo.country_code);
      queryParams.append("return_postal_code", returnInfo.pincode);
      queryParams.append("return_city", returnInfo.city);
      queryParams.append("return_state_name", returnInfo.state);
    }

    // Redirect to the edit page with all parameters
    window.location.replace(
      `/customer/create_order_b2b_1?${queryParams.toString()}`
    );
  };

  const handleChangeSelected = (e, sub) => {
    setSelected((prevSelected) => {
      if (prevSelected.select_order_id.includes(sub.order_number)) {
        // Remove the orderId if it's already in the selected list
        return {
          select_count: prevSelected.select_count - 1,
          select_order_id: prevSelected.select_order_id.filter(
            (id) => id !== sub.order_number
          ),
        };
      } else {
        // Add the orderId if it's not in the selected list
        return {
          select_count: prevSelected.select_count + 1,
          select_order_id: [...prevSelected.select_order_id, sub.order_number],
        };
      }
    });
  };

  const product_list = () => {
    let dataToSend = {};
    // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + "/shipment/all_b2b_product_list";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("responseJson => ", res);
        setproduct(res.data.output);
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const showModal = () => {
    product_list();
    setModalState({ show: true });
  };

  const onChangeProduct = (e) => {
    // console.log("e == " , e)
    let values = Object.assign({}, e.target.value.split(","));
    // console.log("first",values[0])
    let product_id = values[0];
    let carrier_id = values[1];
    setProductselect({
      ...productselect,
      product_id: product_id,
      carrier_id: carrier_id,
    });
  };

  const onsubmit = () => {
    setonSubmit(true);
    let dataToSend = {
      order_id: selected.select_order_id,
      product_id: productselect.product_id,
      carrier_id: productselect.carrier_id,
    };
    // console.log("datatoSend",dataToSend)
    if (productselect.product_id != "" && productselect.carrier_id != "") {
      let url = config.apiUrl + "/shipment/bulk_shipment_booking";
      axios
        .post(url, dataToSend, { headers: config.headers })
        .then((res) => {
          //  console.log("responseJson => ", res);
          if (res.data.status == true) {
            setonSubmit(false);
            navigate(`/customer/bulk_orders_log/${res.data.log_id}`);
          } else {
            setonSubmit(false);
          }
          //  setproduct(res.data.output)
        })
        .catch((error) => {
          //  console.log(error);
          setonSubmit(false);
        });
    } else {
      const Toast = Swal.mixin({
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
      });
      Toast.fire({
        background: "rgb(25, 135, 84)",
        type: "unsuccess",
        title: "Please Select Product Type.",
        color: "white",
      });
    }
  };

  const modalClose = () => {
    setModalState({ show: false });
    setProductselect({ ...productselect, product_id: "", carrier_id: "" });
  };

  const handleSelectAll = (event) => {
    const selectedIds = event.target.checked
      ? state.shipment_list.map((order) => order.order_number)
      : [];

    setSelected({
      select_count: selectedIds.length,
      select_order_id: selectedIds,
    });
  };

  const cancelOrder = (sub) => {
    let dataToSend = {
      order_id: sub.order_number,
    };
    // console.log("datatoSend",dataToSend)

    let url = config.apiUrl + "/shipment/cancel_order";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        //  console.log("responseJson => ", res);
        if (res.data.status == true) {
          shipment_list(null, 0, true);
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "rgb(25, 135, 84)",
            type: "unsuccess",
            title: "Order Cancelled",
            color: "white",
          });
          setOpenOffdetailcanvas(false);
        }
        //  setproduct(res.data.output)
      })
      .catch((error) => {
        //  console.log(error);
      });
  };
  const cancelBulkOrder = () => {
    let dataToSend = {
      order_id: selected.select_order_id,
    };
    // console.log("datatoSend",dataToSend)

    let url = config.apiUrl + "/shipment/cancel_bulk_order";
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        //  console.log("responseJson => ", res);
        if (res.data.status == true) {
          shipment_list(null, 0, true);
          // window.location.reload()
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "rgb(25, 135, 84)",
            type: "unsuccess",
            title: "Orders Cancelled",
            color: "white",
          });
          window.location.reload();
        }
        //  setproduct(res.data.output)
      })
      .catch((error) => {
        //  console.log(error);
      });
  };

  const handlesearchShipment = (e) => {
    setsearchstate({ search_shipment: e.target.value });
  };
  const get_list = async (sortValue, sorting) => {
    console.log("sortValue == ", sortValue);

    setpackageloading({ ...packageloading, loading: true });

    let sort = "default";
    if (sortValue) {
      sort = sortValue;
    }
    const shipment_value = sortValue.invoices.reduce((total, box) => {
      return total + (box.invoice_amount || 0);
    }, 0);
    setWarehouseState({
      warehouse: sortValue.warehouse_id
        ? sortValue.warehouse_id
        : sortValue.warehouse_name,
    });
    let dataToSend = {
      customer_id: sortValue.customer_id,
      from_postal_code: sortValue.sender[0].pincode,
      from_country_code: sortValue.sender[0].country_code,
      from_city_id: sortValue.sender[0].city_id,
      to_postal_code: sortValue.receiver[0].pincode,
      to_country_code: sortValue.receiver[0].country_code,
      weight: sortValue.total_weight,
      length: sortValue.length,
      height: sortValue.height,
      width: sortValue.width,
      sort_by: sort,
      parcel_type: sortValue.type,
      mode: sortValue.mode,
      payment_mode: sortValue.payment_mode,
      order_amount: sortValue.cod_amount,
      carrier_type: 2,
      insurance: sortValue.rv_insurance == true ? 2 : 1,
      shipment_value: shipment_value,
      boxes: sortValue.boxes,
      self: sortValue.self == true ? 1 : 2,
    };

    console.log("datatoSend", dataToSend);
    let url = config.apiUrl + "/shipment/b2b_shipment_rate_time";

    // console.log("headers => ", config.headers);

    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((responseJson) => {
        console.log("responseJson => ", responseJson.data);

        setpackageloading({ ...packageloading, loading: false });
        if (responseJson.data.status == "success") {
          let sortedPackages = responseJson.data.output;

          // Sort the packages based on total charges
          if (sorting === "Cheapest") {
            sortedPackages.sort((a, b) => a.total_charges - b.total_charges);
          } else if (sorting === "Highest") {
            sortedPackages.sort((a, b) => b.total_charges - a.total_charges);
          }
          console.log("sortedPackages = ", sortedPackages);
          setpackageState(sortedPackages);

          if (responseJson.data.output.length == 0) {
            seterrorstate({
              ...errorstate,
              message:
                "No services available for the selected route and package combination.",
            });
          }
        } else {
          //  seterrorstate({...errorstate,message:"No services available for the selected route and package combination."})
          //  console.log("message",responseJson.data.message);
          Swal.fire({
            icon: "error",
            // title: 'Oops...',
            text: "Something Went wrong",
          });
        }
      })
      .catch((error) => {
        //Hide Loader
        setpackageloading({ ...packageloading, loading: false });
        // console.log(error);
      });
  };
  const openOffcanvasHandler = (sub) => {
    setOpenOffcanvas(true);
    setbookorder(sub);
    setSub(sub);
    setallocatedata(sub);
    // Call your get_list function here if needed
    get_list(sub);
  };
  const openOffdetailcanvasHandler = (sub) => {
    setOpenOffdetailcanvas(true);
    setbookorder(sub);
  };
  const closeOffdetailcanvasHandler = () => {
    setOpenOffdetailcanvas(false);
    setbookorder([]);
    // Call your get_list function here if needed
    // get_list(sub);
  };
  const closeOffcanvasHandler = () => {
    setOpenOffcanvas(false);
    setpackageState([]);
    setWarehouseState({ warehouse: "" });
    setbookorder([]);
    setallocatedata([]);
    setSub(null);
    seterrorstate({ ...errorstate, message: "" });
    // Call your get_list function here if needed
    // get_list(sub);
  };

  const submit_detail = async (type, item) => {
    // console.log("type",type)
    // console.log("courier_id",item)
    // console.log("bookorder ===== ", bookorder)
    let bookorder = alloctedata;
    const cleanedSenderMobile = bookorder.sender[0].mobile.replace(/\D/g, "");
    let formattedSenderMobile;
    if (
      cleanedSenderMobile.length > 10 &&
      cleanedSenderMobile.startsWith("91")
    ) {
      formattedSenderMobile = cleanedSenderMobile.substring(2);
    } else {
      formattedSenderMobile = cleanedSenderMobile;
    }
    const cleanedReceiverMobile = bookorder.receiver[0].mobile.replace(
      /\D/g,
      ""
    );
    // const formattedReceiverMobile = cleanedReceiverMobile.startsWith('91')
    //   ? cleanedReceiverMobile.substring(2)
    //   : cleanedReceiverMobile;
    let formattedReceiverMobile;

    if (
      cleanedReceiverMobile.length > 10 &&
      cleanedReceiverMobile.startsWith("91")
    ) {
      formattedReceiverMobile = cleanedReceiverMobile.substring(2);
    } else {
      formattedReceiverMobile = cleanedReceiverMobile;
    }

    // Remove the '+' and '91' prefixes from the mobile number
    const cleanedReturnMobile = bookorder.return[0].mobile.replace(/\D/g, "");
    let formattedReturnMobile;
    if (
      cleanedReturnMobile.length > 10 &&
      cleanedReturnMobile.startsWith("91")
    ) {
      formattedReturnMobile = cleanedReturnMobile.substring(2);
    } else {
      formattedReturnMobile = cleanedReturnMobile;
    }

    let dataToSend = {
      sender_name: bookorder.sender[0].name,
      sender_mobile: formattedSenderMobile,
      sender_email: bookorder.sender[0].email,
      sender_address: bookorder.sender[0].address,
      sender_city: bookorder.sender[0].city,
      sender_city_id: bookorder.sender[0].city_id,
      sender_country_name: bookorder.sender[0].country,
      sender_country_code: bookorder.sender[0].country_code,
      sender_postal_code: bookorder.sender[0].pincode,
      company_name: item ? item.service_name : "",
      receiver_name: bookorder.receiver[0].name,
      receiver_mobile: formattedReceiverMobile,
      receiver_email: bookorder.receiver[0].email,
      receiver_address: bookorder.receiver[0].address,
      receiver_city: bookorder.receiver[0].city,
      receiver_country_name: bookorder.receiver[0].country,
      receiver_country_code: bookorder.receiver[0].country_code,
      receiver_postal_code: bookorder.receiver[0].pincode,
      receiver_state_id: bookorder.receiver[0].state_id,
      receiver_city_id: bookorder.receiver[0].city_id,

      sender_state_name: bookorder.sender[0].state,
      receiver_state_name: bookorder.receiver[0].state,
      return_name: bookorder.return[0].name,
      return_mobile: formattedReturnMobile,
      return_email: bookorder.return[0].email,
      return_address: bookorder.return[0].address,
      return_city: bookorder.return[0].city,
      return_state_name: bookorder.return[0].state,
      return_country_name: bookorder.return[0].country,
      return_country_code: bookorder.return[0].country_code,
      return_postal_code: bookorder.return[0].pincode,
      courier_id: item && item.courier_id ? item.courier_id : "",
      product_id:
        item && item.service_provider_id ? item.service_provider_id : "",
      discount: item && item.discount ? item.discount : 0,
      payment_mode: bookorder.payment_mode,
      shipment_type: bookorder.type,
      cod_amount: bookorder.cod_amount,
      weight: bookorder.total_weight,
      length: bookorder.length,
      height: bookorder.height,
      width: bookorder.width,
      item_name: "",
      item_value: "",
      product_type_name:
        item && item.product_type_name ? item.product_type_name : "",
      total_amount: item
        ? Number(item.total_charges) + Number(item.commission_charge)
        : 0,
      tax_amount: 0,
      rate_price: item ? item.total_charges : 0,
      service_name: item && item.service_provider ? item.service_provider : "",
      carrier_id: item && item.carrier_id,
      insurance_amount: bookorder.insurance_amount
        ? bookorder.insurance_amount
        : 0,
      type: bookorder.type,
      carrier_id: item && item.carrier_id,
      address_id: bookorder.address_id,
      order_id: bookorder.order_number,
      order_date: bookorder.order_date,
      mode: bookorder.mode,
      store_id: bookorder.store_id ? bookorder.store_id : "",
      channel_name: bookorder.channel_name ? bookorder.channel_name : "",
      created_by: "Customer",
      volumetric_weight: item.volumetric_weight,
      channel_id: bookorder.channel_id ? bookorder.channel_id : "",
      total_weight: item.new_weight,
      payment_status: 1,
      payment_type: type != undefined ? type : 0,
      carrier_type: 2,
      order_type: bookorder.order_type
        ? bookorder.order_type == "Fulfilled"
          ? 2
          : 1
        : 1,
      zone_name: item && item.zone_name ? item.zone_name : "",
      boxes: bookorder.boxes,
      invoices: bookorder.invoices,
      boxes_count: bookorder.boxes_count,
      shopify_order_number: bookorder.shopify_order_number
        ? bookorder.shopify_order_number
        : "",
      rv_insurance: bookorder.rv_insurance,
      self: bookorder.self,

      base_rate: item.charge_breakdown.base_rate
        ? item.charge_breakdown.base_rate
        : 0,
      freight_charges: item.charge_breakdown.freight_charges
        ? item.charge_breakdown.freight_charges
        : 0,
      fsc_charges: item.charge_breakdown.fsc_charges
        ? item.charge_breakdown.fsc_charges
        : 0,
      forward_freight: item.charge_breakdown.forward_freight
        ? item.charge_breakdown.forward_freight
        : 0,
      rov_charges: item.charge_breakdown.rov_charges
        ? item.charge_breakdown.rov_charges
        : 0,
      owner_risk_charge: item.charge_breakdown.owner_risk_charge
        ? item.charge_breakdown.owner_risk_charge
        : 0,
      cod_charges: item.charge_breakdown.cod_charges
        ? item.charge_breakdown.cod_charges
        : 0,
      waybill_charge: item.charge_breakdown.waybill_charge
        ? item.charge_breakdown.waybill_charge
        : 0,
      tech_charge: item.charge_breakdown.tech_charge
        ? item.charge_breakdown.tech_charge
        : 0,
      fm_charges: item.charge_breakdown.fm_charges
        ? item.charge_breakdown.fm_charges
        : 0,
      green_tax: item.charge_breakdown.green_tax
        ? item.charge_breakdown.green_tax
        : 0,
      destination_charge: item.charge_breakdown.destination_charge
        ? item.charge_breakdown.destination_charge
        : 0,
      handling_charges: item.charge_breakdown.handling_charges
        ? item.charge_breakdown.handling_charges
        : 0,
      oda_charges: item.charge_breakdown.oda_charges
        ? item.charge_breakdown.oda_charges
        : 0,
      oversize_charge: item.oversize_charge ? item.oversize_charge : 0,
      new_handling_charges: item.new_handling_charge
        ? item.new_handling_charge
        : 0,
      sub_total: item.charge_breakdown.sub_total
        ? item.charge_breakdown.sub_total
        : 0,
      gst: item.charge_breakdown.gst ? item.charge_breakdown.gst : 0,
      lr_number: bookorder.lr_number ? bookorder.lr_number : "",
      documents: bookorder.documents ? bookorder.documents : [],
      order_description: bookorder.order_description
        ? bookorder.order_description
        : "",
      goods_code: bookorder.goods_code ? bookorder.goods_code : "",
    };

    dataToSend.cust_id = bookorder.customer_id;
    console.log("datatoSend", dataToSend);

    let url = config.apiUrl + "/shipment/new_shipment_create";

    setOtherStates({ ...otherState, submit_button: false });
    axios
      .post(url, dataToSend, { headers: config.headers })
      .then((responseJson) => {
        // console.log("responseJson => ", responseJson.data.output);
        setOtherStates({ ...otherState, submit_button: true });
        if (responseJson.data.status == "success") {
          setTimeout(() => {
            setOtherStates({ ...otherState, submit_button: false });
            window.location.replace(`/customer/shipments?type=2`, {
              replace: true,
              state: [],
            });
          }, 2000);
          const Toast = Swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 3000,
          });
          Toast.fire({
            background: "#3659cd",
            type: "unsuccess",
            title: "Shipment booking process starts.",
            color: "white",
          });
        } else {
          setOtherStates({ ...otherState, submit_button: false });
          Swal.fire({
            icon: "error",

            text: responseJson.data.message,
          });
        }
      })
      .catch((error) => {
        setOtherStates({ ...otherState, submit_button: false });
        // console.error(error);
      });
  };

  const dateselect = (e) => {
    setdate({ date: e.target.value });
  };

  const modeChange = (e, value) => {
    if (e.target.checked) {
      setpaymentmode({ ...paymentmode, [e.target.name]: true });
    } else {
      setpaymentmode({ ...paymentmode, [e.target.name]: false });
    }
  };

  const handleWarehouseChange = (e, warehouseId) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedWarehouses([...selectedWarehouses, warehouseId]);
    } else {
      setSelectedWarehouses(
        selectedWarehouses.filter((id) => id !== warehouseId)
      );
    }
  };

  const handleSortChange = (value) => {
    setpackageState([]);
    setSortOption(value);
    if (sub) {
      get_list(sub, value); // Use the updated 'sub' value along with sorting option
    }
  };
  return (
    <div>
      <Left_menu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className="home-section">
        <Header />

        <Modal
          show={modalState.show}
          onHide={() => setModalState({ show: false })}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h6 class="modal-title">Bulk Shipment</h6>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div class="modal-body">
              <div class="card border-0 shadow-sm bg-warning mb-3">
                <div class="card-body">
                  <div class="d-flex justify-content-between">
                    <div class="p-3">
                      <i class="material-icons-outlined">emoji_objects</i>
                    </div>
                    <div class="ps-2 ">
                      <p>
                        Please select the appropiate product type along with
                        Carrier to process the bulk shipment operation. Please
                        check the log for any error.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <label for="" class="form-label">
                Select Product Type:
              </label>
              <select class="form-select" onChange={(e) => onChangeProduct(e)}>
                <option>Select Product Type:</option>
                {product.map((sub) => (
                  <option value={[sub.product_id, sub.carrier_id]}>
                    {sub.product_name} - {sub.carrier_name}
                  </option>
                ))}
              </select>
              {onSubmitButton == false ? (
                <div class="d-grid mt-3">
                  <a
                    class="btn btn-primary btn-block"
                    onClick={() => onsubmit()}
                  >
                    Submit
                  </a>
                </div>
              ) : (
                ""
              )}

              <hr />
              <div class="d-flex justify-content-between mt-3">
                <div class=""></div>
                <div class="">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    data-bs-dismiss="modal"
                    onClick={() => modalClose()}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <div class="row mb-2">
          <div class="col-12 col-md">
            <div class="d-flex">
              <div class="back_btn_wrap">
                <a href="javascript:window.history.back();" class="back_btn">
                  {/* <i data-lucide="corner-up-left"></i> */}
                  <CornerUpLeft />
                </a>
              </div>

              <div class="">
                <h2>Orders</h2>
              </div>
              {/* <!-- <div class="ps-2 ">
                            <select class="form-select form-select-sm">
                                <option>All</option>
                                <option>Domestic</option>
                                <option>International</option>
                            </select>   
                        </div> --> */}
            </div>
          </div>
          <div class="col-12 col-md-5 text-end btns">
            {/* {syncLoading?
             <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={20} />:
            <a onClick={()=>syncOrders()} class="btn btn-secondary-o btn-sm"> <RefreshCcw /> Sync Orders</a>
} */}
            {/* <a href="#" class="btn btn-secondary-o btn-sm"><i data-lucide="refresh-ccw"></i> Sync Orders</a> */}
            <a
              onClick={() =>
                navigate({
                  pathname: "/customer/order_import",
                })
              }
              class="btn btn-secondary-o btn-sm me-2"
            >
              <Upload /> Bulk Orders
            </a>
            <a
              href="/customer/create_order_b2b_1?value=0"
              style={{ cursor: "pointer" }}
              class="btn btn-primary btn-sm"
            >
              <Plus /> Create New Order
            </a>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md">
            <div class="row">
              <div class="col-12 col-md-5">
                <div class="input-group input-group-sm mb-3">
                  {/* <select class="form-select">
                                    <option>Order ID</option>
                                    <option>Phone Number</option>
                                </select> */}
                  <input
                    type="text"
                    class="form-control"
                    name="search_shipment"
                    placeholder="Enter Order Number"
                    onChange={(e) => handlesearchShipment(e)}
                  />
                  <button
                    class="btn btn-outline-primary"
                    onClick={(e) => shipment_list(null, 0, true)}
                  >
                    Search
                  </button>
                </div>
              </div>
              <div class="col-12 col-md-3">
                <input
                  type="date"
                  class="form-control form-control-sm"
                  id="text"
                  placeholder="Enter details name="
                  name="date"
                  onChange={(e) => dateselect(e)}
                />
              </div>
              <div class="col-12 col-md-2 filter_order">
                <div class="dropdown">
                  <button
                    type="button"
                    class="btn btn-theme btn-sm dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Pickup Location
                  </button>
                  <ul class="dropdown-menu">
                    {warehouse.map((sub) => (
                      <li key={sub.address_id}>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id={`warehouseCheckbox${sub.address_id}`}
                            value={sub.address_id}
                            onChange={(e) =>
                              handleWarehouseChange(e, sub.address_id)
                            }
                            checked={selectedWarehouses.includes(
                              sub.address_id
                            )}
                          />
                          <label
                            class="form-check-label"
                            for={`warehouseCheckbox${sub.warehouse_id}`}
                          >
                            {sub.full_name}
                          </label>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div class="col-12 col-md-2 filter_order">
                <div class="dropdown">
                  <button
                    type="button"
                    class="btn btn-theme btn-sm dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    Payment Mode
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="inlineCheckbox1"
                          value="option1"
                          name="cod"
                          onChange={(e) => modeChange(e)}
                          checked={paymentmode.cod}
                        />
                        <label class="form-check-label" for="inlineCheckbox1">
                          Cash On Delivery
                        </label>
                      </div>
                    </li>
                    <li>
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="inlineCheckbox1"
                          value="option1"
                          name="prepaid"
                          onChange={(e) => modeChange(e)}
                          checked={paymentmode.prepaid}
                        />
                        <label class="form-check-label" for="inlineCheckbox1">
                          Prepaid
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2">
          {selected.select_count == 0 ? (
            ""
          ) : (
            <div class="col-12 col-md btns">
              <a href="#" class="btn btn-text btn-sm fw-300">
                <strong>{selected.select_count} selected</strong>
              </a>
              {/* {userstate.aadhar_kyc!=undefined && userstate.aadhar_kyc==true ?  <a class="btn btn-primary btn-sm" onClick={()=>showModal()} data-bs-toggle="modal" data-bs-target="#bulkship"><Truck/> Ship Now</a>: <a class="btn btn-outline-secondary btn-sm" href='/customer/customer_kyc' ><strong></strong> Need Kyc First</a>} */}
              {/* <a href="#" class="btn btn-primary btn-sm"><i data-lucide="truck"></i> Ship Now</a> */}
              <a
                onClick={() => cancelBulkOrder()}
                class="btn btn-outline-danger btn-sm ms-1"
              >
                <Trash /> Delete Orders
              </a>
            </div>
          )}
        </div>

        <div class="content-wrapper-data">
          <div class="card border-0">
            <div class="card-body">
              <div class="table-data table-responsive">
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginLeft: "80px",
                      alignItems: "center",
                      marginTop: "-200px",
                      height: "100vh",
                    }}
                  >
                    <ReactLoading
                      type={"spin"}
                      color={"#0d6efd"}
                      height={40}
                      width={60}
                    />
                  </div>
                ) : (
                  <table class="table table-hover table-responsive">
                    <thead>
                      <tr class="table-light">
                        <th>
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="inlineCheckbox1"
                            value="option1"
                            onChange={handleSelectAll}
                          />
                        </th>
                        <th>Order #</th>
                        <th>Customer Details</th>
                        <th>Payment Mode</th>

                        <th>Package Details</th>
                        {/* <th>Channel</th> */}
                        <th>Pickup Address</th>
                        <th>Product Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {state.shipment_list.map((sub) => (
                        <tr class="ship-now-container">
                          <td>
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="inlineCheckbox1"
                              checked={selected.select_order_id.includes(
                                sub.order_number
                              )}
                              value="option1"
                              onChange={(e) => handleChangeSelected(e, sub)}
                            />
                          </td>
                          <td>
                            <a
                              onClick={() => openOffdetailcanvasHandler(sub)}
                              style={{ cursor: "pointer" }}
                              class="text-primary"
                            >
                              {sub.order_number}
                            </a>
                            <div>
                              <small>
                                {/* <Moment format="MMM DD YYYY">{(sub.order_date)}</Moment> - <Moment format="hh:mm:ss a">
                                      {new Date(sub.order_created * 1000)}
                                    </Moment> */}
                              </small>
                            </div>
                          </td>
                          <td>
                            {sub.receiver.map((item) => (
                              <>
                                {item.name}
                                <div>
                                  <small>
                                    {item.address
                                      .match(/.{1,35}/g)
                                      ?.map((chunk, index) => (
                                        <React.Fragment key={index}>
                                          {chunk}
                                          <br />
                                        </React.Fragment>
                                      ))}
                                  </small>
                                </div>
                                <div>
                                  <small>
                                    {item.city} , {item.state} - {item.pincode}
                                  </small>
                                </div>

                                <div>
                                  <small>{item.mobile}</small>
                                </div>
                              </>
                            ))}
                          </td>

                          <td>
                            {/* <h4>₹ 2000.00</h4> */}
                            <div>
                              <span
                                class={`badge rounded-pill ${
                                  sub.payment_mode == "prepaid"
                                    ? "bg-warning"
                                    : "bg-info"
                                }`}
                              >
                                {sub.payment_mode}
                              </span>
                            </div>
                          </td>

                          <td>
                            Dead wt.:{" "}
                            {sub.boxes?.reduce((total, box) => {
                              const weight = parseFloat(box.box_weight) || 0;
                              const qty = parseInt(box.quantity) || 0;
                              return total + weight * qty;
                            }, 0)}{" "}
                            KG
                          </td>
                          <td>
                            <a
                              href="#"
                              data-bs-toggle="popover"
                              data-bs-trigger="hover"
                              data-bs-content="Mumbai WI, Warli, 400001"
                            >
                              {sub.warehouse_id
                                ? sub.warehouse_id
                                : sub.warehouse_name}
                            </a>
                          </td>

                          <td>
                            {sub.order_description ? sub.order_description : ""}
                            <div class="custom-buttons button-container">
                              <div class="d-flex justify-content-between">
                                <div class="">
                                  <button
                                    type="button"
                                    class="btn btn-primary ship_now"
                                    onClick={() => openOffcanvasHandler(sub)}
                                  >
                                    Ship Now
                                  </button>
                                </div>
                                <div class="p-2 ship_now_2">
                                  <div class="mb-1">
                                    <a
                                      onClick={() => edit_order(sub)}
                                      class="btn btn-secondary btn-sm"
                                      data-bs-toggle="tooltip"
                                      title="Edit Order"
                                    >
                                      <i
                                        class="fa fa-pencil"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </div>
                                  <div class="mb-1">
                                    <a
                                      onClick={(e) => clone_order(sub)}
                                      class="btn btn-secondary btn-sm"
                                      data-bs-toggle="tooltip"
                                      title="Clone Order"
                                    >
                                      <i
                                        class="fa fa-clone"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </div>
                                  <div>
                                    <a
                                      onClick={(e) => cancelOrder(sub)}
                                      class="btn btn-secondary btn-sm"
                                      data-bs-toggle="tooltip"
                                      title="Cancel Order"
                                    >
                                      <i
                                        class="fa fa-ban"
                                        aria-hidden="true"
                                      ></i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>

        {openOffcanvas && (
          <section class="order_info_offcanvas">
            <div class="offcanvas offcanvas-end show" id="Carrier_lists">
              <div class="offcanvas-header">
                <h4 class="offcanvas-title">Select Courier Partner</h4>
                <button
                  type="button"
                  class="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  onClick={() => closeOffcanvasHandler()}
                ></button>
              </div>
              <div class="offcanvas-body">
                <div class="row g-0">
                  <div class="col-12 col-md-4 bg-light show_carrier_left mb_display_none">
                    <div class="row">
                      <div class="col-12 mb-3">
                        <small>Pickup From</small>
                        <p>
                          {bookorder.sender[0].pincode
                            ? bookorder.sender[0].pincode
                            : ""}
                          ,{" "}
                          {bookorder.sender[0].pincode
                            ? bookorder.sender[0].state
                            : ""}
                        </p>
                      </div>
                      <div class="col-12 mb-3">
                        <small>Deliver To</small>
                        <p>
                          {bookorder.receiver[0].pincode
                            ? bookorder.receiver[0].pincode
                            : ""}
                          ,{" "}
                          {bookorder.receiver[0].pincode
                            ? bookorder.receiver[0].state
                            : ""}
                        </p>
                      </div>
                      {/* <div class="col-12 mb-3">
                <small>Order Value</small>
                <p>₹ 100.00</p>
            </div> */}
                      <div class="col-12 mb-3">
                        <small>Payment Mode</small>
                        <p>
                          {bookorder.payment_mode == "cod" ? "COD" : "Prepaid"}
                        </p>
                      </div>
                      {/* <div class="col-12 mb-3">
                      <small>Applicable Weight (in Kg)</small>
                      <p>{bookorder.total_weight} Kg</p>
                    </div> */}
                    </div>
                  </div>
                  <div class="col-12 col-md show_carrier_right">
                    <div class="px-2 mb-1">
                      <div class="row justify-content-between">
                        <div class="col-12 col-md-4">
                          <h5>Available Couriers</h5>
                        </div>
                        <div class="col-12 col-md-4">
                          <select
                            class="form-select"
                            onChange={(e) => handleSortChange(e.target.value)}
                          >
                            <option value="Recommended">
                              Sort By: Recommended
                            </option>
                            <option value="Cheapest">
                              Sort By: Low to High
                            </option>
                            <option value="Highest">
                              Sort By: High to Low
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    {packageloading.loading ? (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <ReactLoading type={"spin"} color={"#0d6efd"} />
                      </div>
                    ) : (
                      ""
                    )}
                    <h3>{errorstate.message}</h3>
                    {packagestate.length > 0 ? (
                      <ul class="list-group">
                        {packagestate.map((item) => (
                          <li class="list-group-item list-group-item-action">
                            <div class="row g-2">
                              <div class="col-md-2">
                                {item.carrier_id == "2433170006" ? (
                                  ""
                                ) : (
                                  <figure>
                                    {/* {dimensionState.companyDetail[0].hide_carrier?"":   */}

                                    <img
                                      src={`https://cdn.mojoship.in/images/${item.carrierImage}`}
                                      class=""
                                      width="100px"
                                    />
                                    {/* } */}
                                  </figure>
                                )}
                              </div>
                              <div class="col-md-4">
                                <h4>{item.service_provider}</h4>
                                <small>
                                  {item.product_type_name
                                    ? item.product_type_name
                                    : ""}
                                </small>
                              </div>
                              <div class="col-md-4">
                                <h6>Applicable Weight</h6>
                                <small>
                                  {Math.max(
                                    item.new_weight,
                                    item.volumetric_weight
                                  ).toFixed(2)}{" "}
                                  Kg
                                </small>
                              </div>
                              {/* <div class="col-2">
                              <h6>Estimated Delivery Days</h6>
                              <small>{item.delivery_days ? `${item.delivery_days}` : ""} </small>
                            </div> */}
                              <div class="col-md-2">
                                <h2>
                                  ₹
                                  {parseFloat(
                                    Number(item.total_charges) +
                                      Number(item.commission_charge)
                                  ).toFixed(2)}
                                </h2>
                                <button
                                  className="btn  btn-sm  p-0"
                                  onClick={() =>
                                    setShowBreakdown(!showBreakdown)
                                  }
                                >
                                  {showBreakdown
                                    ? "Hide details"
                                    : "Show breakdown"}
                                </button>
                              </div>
                              <div class="col-12 col-md-3">
                                <div class="">
                                  <a
                                    onClick={() => submit_detail(1, item)}
                                    class="btn btn-primary"
                                  >
                                    Ship Now
                                  </a>
                                </div>
                              </div>
                            </div>
                            {showBreakdown && item.charge_breakdown && (
                              <div className="col-12 mt-3">
                                <div className="card">
                                  <div className="card-body p-3">
                                    <h6 className="mb-3">Rate Breakdown</h6>
                                    <div className="row">
                                      {Object.entries(
                                        item.charge_breakdown
                                      ).map(([key, value]) => (
                                        <div
                                          className="col-6 col-md-4 mb-2"
                                          key={key}
                                        >
                                          <div className="d-flex justify-content-between">
                                            <span className="text-capitalize">
                                              {key.replace(/_/g, " ")}:
                                            </span>
                                            <span>₹{value}</span>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="offcanvas-backdrop fade show"></div>
          </section>
        )}

        {openOffdetailcanvas && (
          <section className="order_info_offcanvas show">
            <div
              class="offcanvas offcanvas-end order_details show"
              id="order_details"
            >
              <div class="offcanvas-header">
                <div class="offcanvas-title">
                  <div class="row mb-2">
                    <div class="col-12 col-md">
                      <h2>
                        <small>Order #</small>
                        {bookorder.order_number}
                      </h2>
                    </div>
                    <div class="col-12 col-md-2 text-end"></div>
                    <div class="col-12 col-md-4 text-end btns">
                      {/* <a onClick={()=>edit_order(bookorder)} class="btn btn-secondary-o btn-sm me-1" data-bs-toggle="tooltip" title="Edit Order"><FileEdit/></a> */}
                      <a
                        onClick={(e) => clone_order(bookorder)}
                        class="btn btn-secondary-o btn-sm me-1"
                        data-bs-toggle="tooltip"
                        title="Clone Order"
                      >
                        <Copy />
                      </a>
                      <a
                        onClick={(e) => cancelOrder(bookorder)}
                        class="btn btn-secondary-o btn-sm"
                        data-bs-toggle="tooltip"
                        title="Cancel Order"
                      >
                        <Ban />
                      </a>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  class="btn-close text-reset"
                  onClick={() => closeOffdetailcanvasHandler()}
                ></button>
              </div>
              <div class="offcanvas-body">
                <div class="">
                  <div class="row mt-3 order_box_cont">
                    <div class="col-12 col-md-12 ">
                      <div class="card border-0 mb-3">
                        <div class="card-body">
                          <div class="d-flex ">
                            <div class="border-end pe-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                data-lucide="shopping-bag"
                                class="lucide lucide-shopping-bag"
                              >
                                <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"></path>
                                <path d="M3 6h18"></path>
                                <path d="M16 10a4 4 0 0 1-8 0"></path>
                              </svg>
                            </div>
                            <div class="ps-3 ">
                              <h6>Order Details</h6>
                            </div>
                          </div>
                          <hr />
                          <div class="row">
                            <div class="col-12 col-md-6 mb-2">
                              <small class="text-muted">
                                Order created on channel
                              </small>
                              <p>{bookorder.order_date}</p>
                            </div>
                            <div class="col-12 col-md-6 mb-2">
                              <small class="text-muted">
                                Order created on system
                              </small>
                              <p>{bookorder.order_date}</p>
                            </div>
                            <div class="col-12 col-md-6 mb-2">
                              <small class="text-muted">Channel</small>
                              <p>
                                {bookorder.channel_name
                                  ? bookorder.channel_name
                                  : ""}
                              </p>
                            </div>
                            <div class="col-12 col-md-6 mb-2">
                              <small class="text-muted">Invoice value</small>
                              <p>
                                ₹{" "}
                                {bookorder.invoices
                                  .reduce(
                                    (total, sub) =>
                                      total + parseFloat(sub.invoice_amount),
                                    0
                                  )
                                  .toFixed(2)}
                              </p>
                            </div>

                            <div class="col-12 col-md-6 mb-2">
                              <small class="text-muted">Payment Mode</small>
                              <p>
                                {bookorder.payment_mode == "cod"
                                  ? `₹ ${bookorder.cod_amount}`
                                  : ""}{" "}
                                <span class="badge rounded-pill bg-warning">
                                  {bookorder.payment_mode}
                                </span>
                              </p>
                            </div>
                            {/* <div class="col-12 col-md-4 mb-2">
                            <small class="text-muted"> Pickup type </small>
                            <p>{bookorder.self == true ? "Pickup" : "Self Drop"}</p>
                          </div> */}

                            <div class="col-12 col-md-4 mb-2">
                              <small class="text-muted"> Insurance type </small>
                              <p>
                                {bookorder.rv_insurance == true
                                  ? "Carrier Risk"
                                  : "Owner Risk"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card border-0 mb-3">
                        <div class="card-body">
                          <div class="d-flex ">
                            <div class="border-end pe-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                data-lucide="package"
                                class="lucide lucide-package"
                              >
                                <path d="m7.5 4.27 9 5.15"></path>
                                <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"></path>
                                <path d="m3.3 7 8.7 5 8.7-5"></path>
                                <path d="M12 22V12"></path>
                              </svg>
                            </div>
                            <div class="ps-3 ">
                              <h6>Shipment Details</h6>
                            </div>
                          </div>
                          <hr />
                          <div class="row">
                            <div class="col-12 col-md">
                              <h6>Ship From:</h6>
                              <small class="text-muted">Sender Name:</small>
                              <p>{bookorder.sender[0].name}</p>
                              <small class="text-muted">Sender Address:</small>
                              <p>
                                {bookorder.sender[0].address},
                                {bookorder.sender[0].city},{" "}
                                {bookorder.sender[0].state}{" "}
                                {bookorder.sender[0].pincode}
                              </p>
                              <small class="text-muted">Sender Email:</small>
                              <p>{bookorder.sender[0].email}</p>
                              <small class="text-muted">Sender Mobile:</small>
                              <p>{bookorder.sender[0].mobile}</p>
                            </div>
                            <div class="col-12 col-md">
                              <h6>Ship To:</h6>
                              <small class="text-muted">Receiver Name:</small>
                              <p>{bookorder.receiver[0].name}</p>
                              <small class="text-muted">
                                Receiver Address:
                              </small>
                              <p>
                                {bookorder.receiver[0].address},
                                {bookorder.receiver[0].city},{" "}
                                {bookorder.receiver[0].state}{" "}
                                {bookorder.receiver[0].pincode}
                              </p>
                              <small class="text-muted">Receiver Email:</small>
                              <p>{bookorder.receiver[0].email}</p>
                              <small class="text-muted">Receiver Mobile:</small>
                              <p>{bookorder.receiver[0].mobile}</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card border-0  mb-3">
                        <div class="card-body">
                          <div class="d-flex ">
                            <div class="border-end pe-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                data-lucide="package-open"
                                class="lucide lucide-package-open"
                              >
                                <path d="M12 22v-9"></path>
                                <path d="M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z"></path>
                                <path d="M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13"></path>
                                <path d="M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z"></path>
                              </svg>
                            </div>
                            <div class="ps-3 ">
                              <h6>Package Details</h6>
                            </div>
                          </div>
                          <hr />
                          <div class="row">
                            <div class="col-12 col-md-4 mb-2">
                              <small class="text-muted">
                                Applicable Weight (in Kg)
                              </small>
                              <p>----</p>
                            </div>
                            <div class="col-12 col-md-4 mb-2">
                              <small class="text-muted">
                                Dead Weight (in Kg)
                              </small>
                              <p>
                                {bookorder.boxes?.reduce((total, box) => {
                                  const weight =
                                    parseFloat(box.box_weight) || 0;
                                  const qty = parseInt(box.quantity) || 0;
                                  return total + weight * qty;
                                }, 0)}{" "}
                                KG
                              </p>
                            </div>
                            <div class="col-12 col-md-4 mb-2">
                              <small class="text-muted">
                                Volumetric Weight (in kg)
                              </small>
                              <p>----</p>
                            </div>
                            <div class="col-12 col-md-4 mb-2">
                              <small class="text-muted">
                                Dimensions (in cm)
                              </small>
                              <p>
                                {bookorder.height} x {bookorder.width} x{" "}
                                {bookorder.length}
                              </p>
                            </div>
                            {/* <div class="col-12 col-md-6 mb-2">
                        <small class="text-muted">Number of Boxes</small>
                        <p>1</p>
                    </div> */}
                          </div>
                        </div>
                      </div>

                      <div class="card border-0 mb-3">
                        <div class="card-body">
                          <div class="d-flex ">
                            <div class="border-end pe-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                data-lucide="shopping-basket"
                                class="lucide lucide-shopping-basket"
                              >
                                <path d="m15 11-1 9"></path>
                                <path d="m19 11-4-7"></path>
                                <path d="M2 11h20"></path>
                                <path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path>
                                <path d="M4.5 15.5h15"></path>
                                <path d="m5 11 4-7"></path>
                                <path d="m9 11 1 9"></path>
                              </svg>
                            </div>
                            <div class="ps-3 ">
                              <h6>Boxes Details</h6>
                            </div>
                          </div>
                          <hr />
                          <div class="table-responsive ">
                            <table class="table table-light">
                              <thead>
                                <tr>
                                  <th>Length</th>
                                  <th>Width</th>
                                  <th>Height</th>
                                  <th>Weight</th>
                                  <th>Quantity</th>
                                </tr>
                              </thead>
                              <tbody>
                                {bookorder.boxes.map((sub) => (
                                  <tr>
                                    <td>{sub.box_length}</td>
                                    <td>{sub.box_width}</td>
                                    <td>{sub.box_height}</td>
                                    <td>{sub.box_weight}</td>
                                    <td>{sub.quantity}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div class="card border-0 mb-3">
                        <div class="card-body">
                          <div class="d-flex ">
                            <div class="border-end pe-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                data-lucide="shopping-basket"
                                class="lucide lucide-shopping-basket"
                              >
                                <path d="m15 11-1 9"></path>
                                <path d="m19 11-4-7"></path>
                                <path d="M2 11h20"></path>
                                <path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"></path>
                                <path d="M4.5 15.5h15"></path>
                                <path d="m5 11 4-7"></path>
                                <path d="m9 11 1 9"></path>
                              </svg>
                            </div>
                            <div class="ps-3 ">
                              <h6>Invoices Details</h6>
                            </div>
                          </div>
                          <hr />
                          <div class="table-responsive ">
                            <table class="table table-light">
                              <thead>
                                <tr>
                                  <th>Invoice Number</th>
                                  <th>Invoice Amount</th>
                                  <th>Invoice EBN</th>
                                  {/* <th>Total</th> */}
                                </tr>
                              </thead>
                              <tbody>
                                {bookorder.invoices.map((sub) => (
                                  <tr>
                                    <td>{sub.invoice_number}</td>
                                    <td>{sub.invoice_amount}</td>
                                    <td>{sub.invoice_ebn}</td>
                                    {/* <td> {bookorder.invoices.reduce((total, sub) => total + parseFloat(sub.invoice_amount), 0).toFixed(2)}</td> */}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="offcanvas-backdrop fade show"></div>
          </section>
        )}
        <TablePagination
          component="div"
          rowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
          count={otherStates.total_count}
          page={otherStates.page}
          onPageChange={handlePageChange}
          rowsPerPage={otherStates.rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
      <Footer />
    </div>
  );
};

export default Customer_b2b_orders;
